import { angular, app } from '../../app.module'
app
  // ブランドのSNSアカウント編集
  .directive('editBrandSns', () => {
    return {
      restrict: 'E',
      template: require('./edit-brand-sns.pug')(),
      scope: {
        snsType: '@snsType',
        brandId: '@brandId',
      },
      controller: function ($scope, EditBrandModalService, DialogService) {
        // モーダルに紐づけられたスコープから、必要な情報を取得
        let brandId: number = $scope.brandId
        // 入力するユーザ名
        $scope.state = {
          isInput: false,
          inputUsername: '',
        }
        // アカウント情報を初期化
        $scope.addAccount = {}
        // 検索したアカウント情報を初期化(検索結果なしをnullで表す)
        $scope.searchAccount = null
        // 追加状態のメッセージ
        $scope.addAccountMessage = ''
        // 保存可能フラグ
        $scope.saveFlg = false

        // SNSアカウント一覧をブランドにセット
        setSnssAccountList()

        // SNSアカウント一覧をブランドにセット
        function setSnssAccountList() {
          // ブランドのアカウント一覧
          $scope.accounts = []
          // 対象ブランドのSNSのアカウント一覧をセット
          switch ($scope.snsType) {
            // Facebookの場合
            case 'facebook':
              // ブランドIDがある場合
              if (brandId !== undefined) {
                // つけられたFacebookアカウントを取得
                EditBrandModalService.Brand.getFbAccountByBrandId(brandId).then((fbAccounts) => {
                  // フランドが存在する場合
                  if (fbAccounts !== null) {
                    // データをセット
                    fbAccounts.forEach((fbAccount) => {
                      if (fbAccount.accountId !== null) {
                        $scope.accounts.push(fbAccount)
                      }
                    })
                  }
                })
              }

              $scope.labelText = 'ユーザーネーム'
              $scope.hintText = 'https://www.facebook.com/{ユーザーネーム} または {末尾の数字}'
              $scope.followCountText = 'フォロワー数'
              break

            // Twitterの場合
            case 'twitter':
              // つけられたTwitterアカウントを取得
              EditBrandModalService.Brand.getTwAccountByBrandId(brandId).then((twAccounts) => {
                // フランドが存在する場合
                if (twAccounts !== null) {
                  // データをセット
                  twAccounts.forEach((account) => {
                    if (account.accountId !== null) {
                      $scope.accounts.push(account)
                    }
                  })
                }
              })

              $scope.labelText = 'ユーザーネーム'
              $scope.hintText = 'https://x.com/{ユーザーネーム}'
              $scope.followCountText = 'フォロワー数'
              break

            // Instagramの場合
            case 'instagram':
              // つけられたInstagramアカウントを取得
              EditBrandModalService.Brand.getInAccountByBrandId(brandId).then((inAccounts) => {
                // フランドが存在する場合
                if (inAccounts !== null) {
                  // データをセット
                  inAccounts.forEach((account) => {
                    if (account.accountId !== null) {
                      $scope.accounts.push(account)
                    }
                  })
                }
              })

              $scope.labelText = 'ユーザーネーム'
              $scope.hintText = 'https://www.instagram.com/{ユーザーネーム}'
              $scope.followCountText = 'フォロワー数'
              break

            // Tiktokの場合
            case 'tiktok':
              // つけられたTiktokアカウントを取得
              EditBrandModalService.Brand.getTtAccountByBrandId(brandId).then((ttAccounts) => {
                // フランドが存在する場合
                if (ttAccounts !== null) {
                  // データをセット
                  ttAccounts.forEach((account) => {
                    if (account.accountId !== null) {
                      $scope.accounts.push(account)
                    }
                  })
                }
              })

              $scope.labelText = 'ユーザーネーム'
              $scope.hintText = 'https://www.tiktok.com/@{ユーザーネーム}'
              $scope.followCountText = 'フォロワー数'
              break

            // Youtubeの場合
            case 'youtube':
              // つけられたInstagramアカウントを取得
              EditBrandModalService.Brand.getYtAccountByBrandId(brandId).then((ytAccounts) => {
                // フランドが存在する場合
                if (ytAccounts && ytAccounts.length > 0) {
                  // データをセット
                  ytAccounts.forEach((account) => {
                    if (account.accountId !== null) {
                      $scope.accounts.push(account)
                    }
                  })
                }
              })

              $scope.followCountText = 'フォロワー数'
              break

            // Lineの場合
            case 'line':
              // つけられたLineアカウントを取得
              EditBrandModalService.Brand.getLineAccountByBrandId(brandId).then((lineAccounts) => {
                // フランドが存在する場合
                if (lineAccounts && lineAccounts.length > 0) {
                  // データをセット
                  lineAccounts.forEach((account) => {
                    if (account.accountId !== null) {
                      $scope.accounts.push(account)
                    }
                  })
                }
              })

              $scope.labelText = '公式チャンネルURLまたは投稿のURL'
              $scope.hintText =
                'https://timeline.line.me/user/{チャンネルID}' +
                '\nhttps://timeline.line.me/post/{チャンネルID}/{投稿ID}'
              $scope.followCountText = 'フォロワー数'
              break
          }
        }

        // SNSアカウントのユーザ名を入力した際の処理
        $scope.checkInputName = function (username, snsType) {
          // SNSアカウントのチェック中フラグ
          $scope.isCheckSns = true

          // 保存可能フラグ
          $scope.saveFlg = false

          // 入力データが無い場合、初期化
          if (username === '') {
            // 追加アカウント情報
            $scope.addAccount = {}
            // 選択アカウントを非表示にする
            $scope.searchAccount = null
            // エラーメッセージを非表示にする
            $scope.addAccountMessage = ''
            // SNSアカウントのチェック状態を解除
            $scope.isCheckSns = false
          } else {
            // ユーザ名でSNSアカウントをチェックして表示名、フォロワー数、画像、アカウントIDを取得
            EditBrandModalService.BrandSns.checkExistSnsAccount(
              username,
              snsType,
              $scope.accounts
            ).then((result) => {
              // SNSアカウントのチェック状態を解除
              $scope.isCheckSns = false

              // アカウントデータが存在する場合
              if (result !== null && result.status === true) {
                // SNSタイプで判定して表示用のアカウント情報をセット
                switch ($scope.snsType) {
                  // Facebookの場合
                  case 'facebook':
                    $scope.searchAccount = {
                      screenName: result.accountData.name,
                      followers: result.accountData.likes,
                      pictureUrl: result.accountData.picture.data.url,
                    }
                    break

                  // Twitterの場合
                  case 'twitter':
                    $scope.searchAccount = {
                      screenName: result.accountData.name,
                      followers: result.accountData.followers_count,
                      pictureUrl: result.accountData.profile_image_url,
                    }
                    break

                  // Instagramの場合
                  case 'instagram':
                    $scope.searchAccount = {
                      screenName: result.accountData.full_name,
                      pictureUrl: result.accountData.profile_picture,
                      follows: result.accountData.follows,
                      followers: result.accountData.followers,
                    }
                    break

                  // Tiktokの場合
                  case 'tiktok':
                    $scope.searchAccount = {
                      screenName: result.accountData.screen_name,
                      pictureUrl: result.accountData.picture_url,
                      follows: result.accountData.follows,
                      followers: result.accountData.followers,
                      likes: result.accountData.likes,
                      videos: result.accountData.videos,
                    }
                    break

                  // Lineの場合
                  case 'line':
                    $scope.searchAccount = {
                      screenName: result.accountData.screen_name,
                      pictureUrl: result.accountData.picture_url,
                    }
                    break
                }

                // 同じアカウントIDが既に無い場合
                if (result.accountCount === 0) {
                  // アカウント情報をセット
                  $scope.addAccount = result.accountData
                  $scope.addAccountMessage = ''

                  // 保存できるようにする
                  $scope.saveFlg = true
                } else {
                  // 同じアカウントIDが既にある場合、エラーメッセージを表示
                  $scope.addAccountMessage = '別ブランドに登録されているため追加できません。'
                }
              } else {
                // 選択アカウントを非表示にする
                $scope.searchAccount = null

                // アカウントが無い場合、エラーメッセージを表示
                if (result.errorMessage) {
                  $scope.addAccountMessage = result.errorMessage
                } else {
                  switch ($scope.snsType) {
                    case 'facebook':
                    case 'instagram':
                      $scope.addAccountMessage =
                        '対象のアカウントが見つからないか、年齢制限がかかっています。'
                      break
                    default:
                      $scope.addAccountMessage = '対象のアカウントが見つかりません。'
                      break
                  }
                }
              }
            })
          }
        }

        // SNSアカウントが追加された際の処理
        $scope.saveSnsAccount = function () {
          // 編集モーダルを非表示にする
          $scope.state.isInput = false

          // アカウントデータをセット
          const accountInfo = $scope.addAccount

          // SNSアカウントタイプ
          accountInfo.snsType = $scope.snsType
          accountInfo.brandId = $scope.brandId

          brandId = $scope.brandId
          // サーバーへPOSTする
          EditBrandModalService.BrandSns.saveSnsAccount({
            accountData: accountInfo,
          })
            .then((result) => {
              // データがある場合
              if (result !== null) {
                // 入力するユーザ名をリセット
                $scope.state.inputUsername = ''

                // 保存フラグをリセット
                $scope.saveFlg = false

                // 選択アカウントを非表示にする
                $scope.searchAccount = null

                // アカウント情報が追加されたことを親スコープへ通知
                setSnssAccountList()
                $scope.$emit('changeBrandsList')
              }
            })
            .catch(() => {
              DialogService.showToast(
                'アカウントの保存に失敗しました。恐れ入りますが再度お試しください。',
                'error-toast'
              )
            })
        }

        $scope.cancelForm = function () {
          $scope.state.isInput = false
          $scope.state.inputUsername = ''

          $scope.searchAccount = null
        }

        // ブランドを削除する処理
        $scope.deleteSnsAccount = function (accountId, snsType) {
          // 確認メッセージ
          if (confirm('アカウントのデータが全て削除されます。本当に削除してよろしいですか?')) {
            // サーバーへPOSTする
            EditBrandModalService.BrandSns.deleteSnsAccount(accountId, snsType).then(() => {
              // アカウント情報が削除されたことを親スコープへ通知
              setSnssAccountList()
              $scope.$emit('changeBrandsList')
            })
          }
        }

        // ブランドのデータ取得フラグを更新する処理
        $scope.setDataFlg = function (accountId, targetSns) {
          // サーバーへPOSTする
          EditBrandModalService.BrandSns.setDataFlg(accountId, targetSns).then(() => {
            // アカウント情報が更新されたことを親スコープへ通知
            setSnssAccountList()
          })
        }

        // アカウント登録フォームでEnterを入力した時
        $scope.enterInputForm = function () {
          // フォーカスをはずす
          angular.element('.username-input-form').blur()
        }
      },
    }
  })
